class SubordinatesInBuController {
    /*@ngInject*/
    constructor(userService, alertsAndNotificationsService) {
        this.userService = userService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
    }
    $onInit() {
        this.users = [];
        this.loading = true;
        this.getUsersInBu();
    }
    getUsersInBu() {
        this.loading = true;
        this.userService.getSubordinatesByBu(this.userId, this.buId, (data) => {
            this.users = data;
            this._massageUsersData();
            this.loading = false;
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    _massageUsersData() {
        this.users.forEach((user) => {
            user.name = user.firstName + " " + user.lastName;
        });
    }
}
SubordinatesInBuController.$inject = ['userService', 'alertsAndNotificationsService'];
// import * as TEMPLATE from './subordinates-in-bu.html';
import * as TEMPLATE from 'raw-loader!./subordinates-in-bu.html';
export const SubordinatedInBuComponent = {
    selector: 'subordinatesInBu',
    component: {
        bindings: {
            userId: '@',
            buId: '@'
        },
        controller: SubordinatesInBuController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/addEditUser/subordinatesInBu/subordinates-in-bu.html'
    }
};
//# sourceMappingURL=subordinates-in-bu.component.js.map